import { apiFetch } from './client';

export const commentDmAPI = {
  getRules: (accountId) =>
      apiFetch(`/comment-dm/account/${accountId}/rules`),

  createRule: (data) =>
      apiFetch('/comment-dm/rules', {
        method: 'POST',
        body: JSON.stringify(data),
      }),

  updateRule: (ruleId, data) =>
      apiFetch(`/comment-dm/rules/${ruleId}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),

  toggleRule: (ruleId) =>
      apiFetch(`/comment-dm/rules/${ruleId}/toggle`, { method: 'PATCH' }),

  deleteRule: (ruleId) =>
      apiFetch(`/comment-dm/rules/${ruleId}`, { method: 'DELETE' }),

  getPosts: (accountId) =>
      apiFetch(`/comment-dm/account/${accountId}/posts`),

  getLogs: (accountId) =>
      apiFetch(`/comment-dm/account/${accountId}/logs`),
};
